"use strict";
/**
* Copyright: Microsoft 2016
*/
Object.defineProperty(exports, "__esModule", { value: true });
var componentLocalizer_1 = require("./component/componentLocalizer");
var icu_1 = require("./standards/icu");
var internal_1 = require("./types/internal");
var localizationLoader_1 = require("./loader/localizationLoader");
var logger_1 = require("./common/logger");
var stringLocalizer_1 = require("./string/stringLocalizer");
var Localizer = /** @class */ (function () {
    function Localizer() {
        var _this = this;
        this.providers = [];
        this.getString = function (text, params) {
            return _this.get(text, params);
        };
        this.get = function (text, params) {
            return componentLocalizer_1.componentLocalizer.get(text, params);
        };
        this.has = function (key) {
            return internal_1.internalStringLoader.hasString(key);
        };
        this.toLocalizedComponent = function (key, params) {
            return icu_1.default.formatComponent(key, params);
        };
        this.toLocalizedString = function (key, params) {
            return icu_1.default.formatString(key, params);
        };
    }
    Localizer.prototype._init = function (settings) {
        this.locale = settings.locale;
        this.fallback = settings.fallback;
        //@todo enable override of stringReplacer
        internal_1.internalStringReplacer.init(stringLocalizer_1.stringLocalizer);
        //@todo enable override of stringLoader
        internal_1.internalStringLoader.init(localizationLoader_1.localizationLoader);
        logger_1.logger.init(settings);
        componentLocalizer_1.componentLocalizer.init(settings);
    };
    Localizer.prototype.initSync = function (settings) {
        this._init(settings);
        localizationLoader_1.localizationLoader.initSync(settings);
    };
    Localizer.prototype.initAsync = function (settings) {
        this._init(settings);
        return this;
    };
    Localizer.prototype.loadAsync = function (providers) {
        var _this = this;
        var _loop_1 = function (p) {
            if (0 === this_1.providers.filter(function (e) { return e.getFilename(_this.locale) === p.getFilename(_this.locale); }).length) {
                this_1.providers.push(p);
            }
        };
        var this_1 = this;
        for (var _i = 0, providers_1 = providers; _i < providers_1.length; _i++) {
            var p = providers_1[_i];
            _loop_1(p);
        }
        return localizationLoader_1.localizationLoader.initAsync(providers, this.locale, this.fallback);
    };
    Localizer.prototype.isRtlLanguage = function () {
        var currentLocale = this.locale.toLowerCase().split('-')[0];
        return currentLocale === 'ar' || currentLocale === 'he' || currentLocale === 'iw';
    };
    Localizer.prototype.getLocale = function () {
        return this.locale;
    };
    Localizer.prototype.switchLanguage = function (language, fallback) {
        this.locale = language;
        this.fallback = fallback || this.fallback;
        return localizationLoader_1.localizationLoader.initAsync(this.providers, this.locale, this.fallback, true);
    };
    return Localizer;
}());
exports.Localizer = Localizer;
exports.localizer = new Localizer();
